import api from '@pray/shared/utils/api';

export async function deleteOffer({ artistId = undefined, offerId = undefined }) {
  if (!offerId) throw new Error('Offer ID is required');

  const url = `/web/studio/offers/${offerId}?artist_id=${artistId}`;
  const response = await api.executeDeleteRequest(url);

  return response.data;
}
